import { render, staticRenderFns } from "./account-file-upload.vue?vue&type=template&id=00649f6f&scoped=true&"
import script from "./account-file-upload.vue?vue&type=script&lang=js&"
export * from "./account-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./account-file-upload.vue?vue&type=style&index=0&id=00649f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00649f6f",
  null
  
)

export default component.exports